import { FEATURE_FLAG_ROUTE_NAME } from '@/libs/route-name'

export const featureFlagRoute = () => {
  return {
    name: FEATURE_FLAG_ROUTE_NAME.FEATURE_FLAG,
    path: 'feature-flags',
    component: () => import('@/pages/feature-flags/index.vue'),
  }
}
